import Entity from './Entity';
import AccessRole from './AccessRole';
import UserRole from './UserRole';
import Tenant from './Tenant';
import { TenantMembership } from './TenantMembership';

export default interface User extends Entity {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  avatarUrl: string;
  roles: AccessRole[];
  userRoles: UserRole[];
  enabled?: boolean;
  tenant?: Tenant;
  permissionUUIDs?: string[];
  additionalTenants?: TenantMembership[];
}

export enum UserEvents {
  UPDATE = 'UPDATE',
}
